import Spinner from "../Spiner/Spiner"
import React, { useEffect, useState } from "react"
import CustomFirstStepTable from "./CreditReportTable/FirstStepTable/CustomFirstStepTable"
import { NoData } from "../Icons/Icons"
import CustomSpinner from "../Spiner/CustomSpiner"
import AddDebtManual from "../../containers/Contacts/add-contact/CreditSelect/AddDebtManual"
import { validateForm } from "../../containers/Contacts/add-contact/CreditSelect/helper"
import { useManualDebtRules } from "../../containers/Contacts/add-contact/CreditSelect/useManualDebtRules"
import { now } from "../../utils/date"

const FirstStep = ({
  loading,
  data,
  setData,
  selectedRows,
  setSelectedRows,
  loaded,
  userId,
  update,
  setUpdate,
  debtsToDelete,
  setDebtsToDelete,
  setTriggerFetchDebts,
  isUpdate,
  creditReport,
}) => {

  const initialFieldSet = {
    creditReport: creditReport?._id,
    accountType: "",
    accountNumber: "",
    openedDate: now(),
    reportedDate: now(),
    closedDate: now(),
    lastPaymentDate: now(),
    accountStatus: "",
    isOpenAccount: "",
    creditorName: "",
    balanceAmount: "",
    pastDueAmount: "",
    creditLimit: "",
  }
  const manualDebtRules = useManualDebtRules()
  const [fields, setFields] = useState([initialFieldSet])
  const [errors, setErrors] = useState([])

  useEffect(() => {
    validateForm({ fields, setErrors, rules: manualDebtRules })
  }, [fields, manualDebtRules])

  return (
    <div className="mt-6">
      <div className="flex justify-between items-center">
        <div className="my-6">
          <div className="text-lg-18 font-bold text-text-primary">Choose debts</div>
          {Array.isArray(debtsToDelete) && debtsToDelete?.length > 0 &&
            <div className="text-sm italic text-text-secondary">Items will be deleted after confirmation in step 3</div>}
        </div>
        <AddDebtManual errors={errors} setErrors={setErrors} setFields={setFields} fields={fields}
          reportId={creditReport?._id}
          userId={userId} initialFieldSet={initialFieldSet} setUpdate={setUpdate} update={update}
          showFieldErrors={true} rules={manualDebtRules} />
      </div>
      {loading && <Spinner />}
      <CustomFirstStepTable data={data} setData={setData} setSelectedRows={setSelectedRows}
        selectedRows={selectedRows} debtsToDelete={debtsToDelete}
        setDebtsToDelete={setDebtsToDelete}
        setTriggerFetchDebts={setTriggerFetchDebts} isUpdate={isUpdate} />
      {loaded ? data?.length > 0 ? "" :
        <div className="w-full flex justify-center items-center flex-col mt-8 ">
          <NoData />
          <p>No credits are found</p>
        </div> : <div className="mt-20 "><CustomSpinner /></div>
      }
    </div>
  )

}
export default FirstStep